module.exports = __webpack_public_path__ + "img/Frame7.9159bff4.png";